import {
    type GetAllEventsForAdminResponseType
} from "./type";
import {
    request
} from "../request";

const getAllEventsForAdmin = async (): Promise<GetAllEventsForAdminResponseType> => {
    return await request<GetAllEventsForAdminResponseType>("/events/getAllEventsForAdmin", {
        method: "GET"
    });
};

export default getAllEventsForAdmin;
